import React from "react";
import { Dialog } from "../../base/Dialog/Dialog.jsx";
import { Button, buttonThemeColors } from "../../base/Button/Button.jsx";
import { GridContainerFlex } from "../../layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import { GridItemFlex } from "../../layout/GridFlex/GridItemFlex/GridItemFlex.jsx";

export const InfoDialog = ({
    title,
    onClose,
    description,
    confirmBtnText = "Close",
    width = 500,
    textAlign = "center",
    ...otherProps
}) => {
    return (
        <Dialog
            title={title}
            onClose={onClose}
            width={width}
            {...otherProps}
        >
            <GridContainerFlex direction="column" gap="16px">
                <GridItemFlex style={{ textAlign }}>
                    {description}
                </GridItemFlex>
                <GridItemFlex>
                    <GridContainerFlex justifyContent="center">
                        <GridItemFlex>
                            <Button
                                themeColor={buttonThemeColors.primary}
                                onClick={onClose}
                            >
                                {confirmBtnText}
                            </Button>
                        </GridItemFlex>
                    </GridContainerFlex>
                </GridItemFlex>
            </GridContainerFlex>
        </Dialog>
    );
};